import { useTranslation } from "react-i18next"
import { SelectContent, SelectItem, SelectRoot, SelectTrigger, SelectValueText } from "../../ui/select"
import { colors } from "../../../utilities/colors"

export default function SaleTypeSelect({ collection, value, onChange }) {
  const { t } = useTranslation()

  return (
    <SelectRoot
      collection={collection}
      value={value}
      size="sm"
      positioning={{ sameWidth: true, placement: "bottom" }}
      onValueChange={(selection) => onChange(selection.value)}
      multiple={false}
    >
      <SelectTrigger
        borderWidth={2}
        borderColor={colors.grey}
        _focus={{ borderColor: colors.grey300 }}
        rounded="md"
        p={2}
      >
        <SelectValueText placeholder={t("Select Sale Type")} />
      </SelectTrigger>
      <SelectContent portalled={false} width="full">
        {collection.items.map((item) => (
          <SelectItem item={item} key={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </SelectContent>
    </SelectRoot>
  )
}
